import React from "react";
import { useAuth } from "../../contexts/authContext";
import { Navigate, Link } from 'react-router'


export const AuthenticationGuard = ({ component:C }) => {
  const { userLoggedIn} = useAuth();
/*
  const Component = 

  
  const Component = withAuthenticationRequired(component, {
    onRedirecting: () => (
      <div className="page-layout">
      </div>
    ),
  });
  return <Component />;
    */

  return (
    <>
        {userLoggedIn ? <C/> : <Navigate to='/login'/>}
    </>
  )
};